import React from 'react'
import Layout from '../../common/Layout'
import AdviserProfilesContainer from '../../features/AdministrationPortal/Whitelisting/AdviserProfilesContainer/AdviserProfilesContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/whitelisting',
  async action () {
    return {
      title: 'Whitelisting',
      component: <Layout containerWell>
        <AdviserProfilesContainer />
      </Layout>
    }
  }
}
